import React, { useState, useEffect } from 'react';
import {
  formatNumberDecimal,
  KTSVG,
  SimpleAlert,
} from '../../../../_mexablock/helpers';
import { ProgressDash } from '../../../../_mexablock/helpers/components/ProgressDashboard';
import { useGetAllIndicators } from '../../../modules/profile/hooks/profileHook';
import { useSelectCuentas } from '../hooks/DashboardHook';
import {
  downloadPDF as pdfActivaciones,
  downloadExcel as excelActivaciones,
} from '../../../service/reportes/Activaciones';
import {
  downloadPDF as pdfPortability,
  downloadExcel as excelPortability,
} from '../../../service/reportes/Portability';
import {
  downloadPDF as pdfRecharge,
  downloadExcel as excelRecargas,
} from '../../../service/reportes/Recargas';
import { colors } from 'react-select/dist/declarations/src/theme';

type Props = {
  init_date?: string;
  end_date?: string;
};

const Indicators: React.FC<Props> = ({ init_date, end_date }) => {
  let fechaActual = new Date();
  let fecha_inicio_init = new Date(
    fechaActual.getFullYear(),
    fechaActual.getMonth(),
    1,
  );
  let fecha_fin_init = new Date();
  const [initFilterValues, setInitFilterValues] = useState({
    init_date:
      init_date || new Date(fecha_inicio_init).toISOString().split('T')[0],
    end_date: end_date || new Date(fecha_fin_init).toISOString().split('T')[0],
  });

  useEffect(() => {
    if (init_date !== undefined && end_date !== undefined) {
      setInitFilterValues({
        init_date,
        end_date,
      });
    }
  }, [init_date, end_date]);
  const [reloadGrid] = useState(Math.random() * 40);
  const [dataIndicators, setDataIndicators] = useState<any>(null);
  const [loadingPdf, setLoadingPdf] = useState<number | null>(null);
  const [loadingExcel, setLoadingExcel] = useState<number | null>(null);
  const { data } = useSelectCuentas(reloadGrid);
  const { dataIndicators: initialIndicators } = useGetAllIndicators(
    reloadGrid,
    initFilterValues,
  );

  const {
    activations = 0,
    portabilities = 0,
    recharges = 0,
    globalTotal = 0,
  } = dataIndicators || {};

  const percentageActivations =
    globalTotal > 0
      ? Number(((activations / globalTotal) * 100).toFixed(2))
      : 0;
  const percentagePortabilities =
    globalTotal > 0
      ? Number(((portabilities / globalTotal) * 100).toFixed(2))
      : 0;
  const percentageRecharges =
    globalTotal > 0 ? Number(((recharges / globalTotal) * 100).toFixed(2)) : 0;

  useEffect(() => {
    if (initialIndicators) {
      setDataIndicators(initialIndicators);
    }
  }, [initialIndicators]);

  const obtenerPeriodo = () => {
    const fecha = new Date();
    const mes = fecha.toLocaleDateString('es-ES', { month: 'long' });
    const año = fecha.getFullYear();
    return `${mes.charAt(0).toUpperCase() + mes.slice(1)} ${año}`;
  };

  const handleDownloadPDFAct = async (TypeReport: number) => {
    setLoadingPdf(TypeReport);
    try {
      if (TypeReport == 1) await pdfActivaciones(initFilterValues, true);
      if (TypeReport == 2) await pdfPortability(initFilterValues, true);
      if (TypeReport == 3) await pdfRecharge(initFilterValues, true);
    } catch (error: any) {
      SimpleAlert(error.message || 'Error al descargar el PDF', 4000, 'error');
    } finally {
      setLoadingPdf(null);
    }
  };

  const handleDownloadExcelAct = async (TypeReport: number) => {
    setLoadingExcel(TypeReport);
    try {
      if (TypeReport == 1) await excelActivaciones(initFilterValues, true);
      if (TypeReport == 2) await excelPortability(initFilterValues, true);
      if (TypeReport == 3) await excelRecargas(initFilterValues, true);
    } catch (error: any) {
      SimpleAlert(
        error.message || 'Error al descargar el Excel',
        4000,
        'error',
      );
    } finally {
      setLoadingExcel(null);
    }
  };

  return (
    <>
      {!dataIndicators ? null : (
        <div className="container-fluid px-0">
          <div className="row g-2 g-lg-3 justify-content-between w-100 mb-9">
            <div className="col">
              <div className="card card-flush h-100">
                <div className="card-header pt-5">
                  <div className="card-title d-flex flex-column">
                    <span className="text-primary pb-2 fw-semibold fs-5">
                      Balance
                    </span>
                    <div className="d-flex align-items-center">
                      <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                        $
                      </span>
                      <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                        {formatNumberDecimal(globalTotal ? globalTotal : 0)}
                      </span>
                    </div>
                    {/* <span className="fs-9 text-gray-600">
                      Periodo: {obtenerPeriodo()}
                    </span> */}
                    <div className="d-flex gap-3 w-100 flex-grow-1 pt-2">
                      <ProgressDash
                        porcentaje={
                          percentageActivations ? percentageActivations : 0
                        }
                        color="#883DCF"
                      />
                      <ProgressDash
                        porcentaje={
                          percentagePortabilities ? percentagePortabilities : 0
                        }
                        color="#F86624"
                      />
                      <ProgressDash
                        porcentaje={
                          percentageRecharges ? percentageRecharges : 0
                        }
                        color="#2BB2FE"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Activaciones */}
            <div className="col">
              <div className="card card-flush h-100">
                <div className="card-header pt-5">
                  <div className="card-title d-flex flex-column">
                    <span className="text-info pb-2 fw-bold fs-5">
                      Activaciones
                    </span>
                    <div className="d-flex align-items-center">
                      <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                        $
                      </span>
                      <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                        {formatNumberDecimal(activations ? activations : 0)}
                      </span>
                    </div>

                    <div className="d-flex rounded mt-3">
                      <button
                        className="btn btn-sm btn-light-success fs-10"
                        style={{ minWidth: '50px' }}
                        disabled={loadingExcel === 1 || activations == 0}
                        onClick={() => handleDownloadExcelAct(1)}
                      >
                        {loadingExcel === 1 ? (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Descargando...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        ) : (
                          <>
                            <KTSVG
                              path="/media/icons/duotune/files/fil029.svg"
                              className="svg-icon-5 svg-icon-gray-500 me-1"
                            />
                            Descargar
                          </>
                        )}
                      </button>

                      <button
                        className="btn btn-sm btn-light-danger fs-10"
                        style={{ minWidth: '50px' }}
                        disabled={loadingPdf === 1 || activations == 0}
                        onClick={() => handleDownloadPDFAct(1)}
                      >
                        {loadingPdf === 1 ? (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Descargando...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        ) : (
                          <>
                            <KTSVG
                              path="/media/icons/duotune/files/fil030.svg"
                              className="svg-icon-5 svg-icon-gray-500 me-1"
                            />
                            Descargar
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Portabilidad */}
            <div className="col">
              <div className="card card-flush h-100">
                <div className="card-header pt-5">
                  <div className="card-title d-flex flex-column">
                    <span className=" text-warning pb-2 fw-bold fs-5">
                      Portabilidad
                    </span>
                    <div className="d-flex align-items-center">
                      <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                        $
                      </span>
                      <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                        {formatNumberDecimal(portabilities ? portabilities : 0)}
                      </span>
                    </div>

                    <div className="d-flex rounded mt-3">
                      <button
                        className="btn btn-sm btn-light-success fs-10"
                        style={{ minWidth: '50px' }}
                        disabled={loadingExcel === 2 || portabilities == 0}
                        onClick={() => handleDownloadExcelAct(2)}
                      >
                        {loadingExcel === 2 ? (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Descargando...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        ) : (
                          <>
                            <KTSVG
                              path="/media/icons/duotune/files/fil029.svg"
                              className="svg-icon-5 svg-icon-gray-500 me-1"
                            />
                            Descargar
                          </>
                        )}
                      </button>

                      <button
                        className="btn btn-sm btn-light-danger ms-2 fs-10"
                        style={{ minWidth: '50px' }}
                        disabled={loadingPdf === 2 || portabilities == 0}
                        onClick={() => handleDownloadPDFAct(2)}
                      >
                        {loadingPdf === 2 ? (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Descargando...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        ) : (
                          <>
                            <KTSVG
                              path="/media/icons/duotune/files/fil030.svg"
                              className="svg-icon-5 svg-icon-gray-500 me-1"
                            />
                            Descargar
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Recargas */}
            <div className="col">
              <div className="card card-flush h-100">
                <div className="card-header pt-5">
                  <div className="card-title d-flex flex-column">
                    <span className="text-primary pb-2 fw-bold fs-5">
                      Recargas
                    </span>
                    <div className="d-flex align-items-center">
                      <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                        $
                      </span>
                      <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                        {formatNumberDecimal(recharges ? recharges : 0)}
                      </span>
                    </div>

                    <div className="d-flex rounded mt-3">
                      <button
                        className="btn btn-sm btn-light-success fs-10"
                        style={{ minWidth: '50px' }}
                        disabled={loadingExcel === 3 || recharges == 0}
                        onClick={() => handleDownloadExcelAct(3)}
                      >
                        {loadingExcel === 3 ? (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Descargando...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        ) : (
                          <>
                            <KTSVG
                              path="/media/icons/duotune/files/fil029.svg"
                              className="svg-icon-5 svg-icon-gray-500 me-1"
                            />
                            Descargar
                          </>
                        )}
                      </button>

                      <button
                        className="btn btn-sm btn-light-danger ms-2 fs-10"
                        style={{ minWidth: '50px' }}
                        disabled={loadingPdf === 3 || recharges == 0}
                        onClick={() => handleDownloadPDFAct(3)}
                      >
                        {loadingPdf === 3 ? (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Descargando...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        ) : (
                          <>
                            <KTSVG
                              path="/media/icons/duotune/files/fil030.svg"
                              className="svg-icon-5 svg-icon-gray-500 me-1"
                            />
                            Descargar
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Indicators;
